import type { CheckoutRequestFirestore } from '@rye-com/rye-data-layer';

import { CollectionId, FirebaseCollection } from 'app/firebase';

import {
  AmazonBusinessAccount,
  BillingMonthly,
  BillingNotifications,
  BillingPrePayment,
  BillingSubscription,
  Brand,
  InventoryRequestLimits,
  StripeConfig,
} from 'app/graphql/generated/admin/graphql';

export type CheckoutRequestFirestoreModel = CheckoutRequestFirestore & {
  autoCancelTask: {
    name: string;
  };
};

export enum AuthProvider {
  Local = 'local',
  Google = 'google',
  Firebase = 'firebase',
}

export interface UserModel {
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;
  apiKey: string;
  apiKeySecondary?: string | null;
  adminToken?: string | null;
  authProvider: AuthProvider;
  email: string | null;
  uid: string;
  webhookURL: string;
  webhookURLVerified?: boolean;
  marginAmount: number;
  marginIsPercent: boolean; // $ = any > 0, % = 0-100
  photoURL?: string | null;
  isApprovedForDirectCheckout?: boolean | null;
  onBoardingPresentationComplete?: boolean;
  amazonBusinessAccount?: AmazonBusinessAccount | null;
  stripe?: StripeConfig | null;
  website?: string | null;
  firstRequestAt?: {
    nanoseconds: number;
    seconds: number;
  } | null;
  inventoryRequestLimits?: InventoryRequestLimits | null;
  jwtValidationKey?: string | null;
  hmacSecretKey: string;
  brand?: Brand | null;
  createdAt?: {
    nanoseconds: number;
    seconds: number;
  } | null;
  billingPeriodSettings?: BillingPrePayment | BillingMonthly | BillingSubscription | null;
  isReadOnly: boolean;
  accessScopes: string[];
  billingNotificationSettings?: BillingNotifications;
}

class UsersCollection extends FirebaseCollection {
  constructor() {
    super(CollectionId.Users);
  }

  fetchCheckoutRequestByOrderId = async (
    userUid: string,
    orderId: string,
  ): Promise<CheckoutRequestFirestoreModel | undefined> => {
    const resp = await this.get<CheckoutRequestFirestoreModel>(
      `/${userUid}/checkoutRequests/${orderId}`,
    );

    return resp;
  };
}

export const usersCollection = new UsersCollection();
